export default "__VITE_ASSET__BeqFDrkY__"